export default __webpack_public_path__ + "static/media/float-right.a595de25.svg";